import { useState, useEffect } from 'react';
import {
    MDBCard,
    MDBCardBody,
    MDBBtn,
    MDBIcon,
    MDBTypography,
    MDBSpinner
} from 'mdb-react-ui-kit';
import {
    checkMetaConnection,
    disconnectWhatsAppMeta,
    getwhatsAppPartnerInfo,
    metaOAuthComplete
} from '../../services/apiServices';
import LeftPane from '../../components/LeftPane';
import Header from '../../components/Header';

export default function WhatsAppSignup({ onRegistrationSuccess }) {
    const [isConnected, setIsConnected] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [accountInfo, setAccountInfo] = useState(null);

    const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;

    useEffect(() => {
        checkConnectionStatus();
        loadFacebookSDK();
        checkExistingWABA()
    }, []);

    const checkConnectionStatus = async () => {
        try {
            if (!gymid) return;

            const response = await checkMetaConnection(gymid);
            const data = await response.json();

            if (data.success && data.isConnected) {
                setIsConnected(true);
                setAccountInfo(data.account);
            }
        } catch (err) {
            console.error('Error checking connection status:', err);
        }
    };
    const checkExistingWABA = async () => {
        try {
            const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
            if (!gymid) return;

            const response = await getwhatsAppPartnerInfo(gymid)

            if (response.ok) {
                const data = await response.json();
                if (data.success && data.data?.waba_verified) {
                    // setWabaStatus(data.data);
                    onRegistrationSuccess?.(data.data);
                }
            }
        } catch (error) {
            console.error('Error checking WABA status:', error);
        }
    };

    const loadFacebookSDK = () => {
        if (document.getElementById('facebook-jssdk')) return;

        window.fbAsyncInit = function () {
            window.FB.init({
                appId: '1125100298532703', // your app id
                cookie: true,
                xfbml: false,
                version: 'v19.0'
            });
            console.log('✅ Facebook SDK initialized');
        };

        const script = document.createElement('script');
        script.id = 'facebook-jssdk';
        script.src = 'https://connect.facebook.net/en_US/sdk.js';
        script.async = true;
        document.body.appendChild(script);
    };

    const handleOAuthComplete = async (code) => {
        try {
            const response = await metaOAuthComplete({ code, gymid });
            const data = await response.json();

            if (response.ok && data.success) {
                setIsConnected(true);
                setAccountInfo(data.account);
                setError(null);
            } else {
                setError(data.message || 'Failed to connect WhatsApp account');
            }
        } catch (err) {
            setError('Network error. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const launchWhatsAppSignup = () => {
        if (!window.FB) {
            setError('Facebook SDK not loaded. Refresh page.');
            return;
        }

        if (!gymid) {
            setError('Gym ID missing. Please log in again.');
            return;
        }

        setIsLoading(true);
        setError(null);

        window.FB.login(
            function (response) {
                if (response.authResponse && response.authResponse.code) {
                    handleOAuthComplete(response.authResponse.code);
                } else {
                    setIsLoading(false);
                    if (response.status === 'not_authorized') {
                        setError('You cancelled the connection process.');
                    } else {
                        setError('Failed to connect. Please try again.');
                    }
                }
            },
            {
                config_id: '929246719561743',
                response_type: 'code',
                override_default_response_type: true,
                scope: "business_management,whatsapp_business_management,whatsapp_business_messaging",
                extras: {
                    setup: {
                        // Add business profile info
                        business: {
                            name: 'Your Business Name',
                            email: 'business@email.com',
                            country: 'IN'
                        }
                    }
                },
                state: gymid.toString()
            }
        );
    };

    const disconnectWhatsApp = async () => {
        try {
            const response = await disconnectWhatsAppMeta(gymid);
            const data = await response.json();

            if (data.success) {
                setIsConnected(false);
                setAccountInfo(null);
                setError(null);
            } else {
                setError(data.message || 'Failed to disconnect');
            }
        } catch (err) {
            setError('Failed to disconnect.');
        }
    };

    return (
    
    <div style={{
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
        display: 'flex',
        justifyContent: 'center',
        padding: '20px',
        paddingTop: '100px'
    }}>
        <div style={{ maxWidth: '500px', width: '100%' }}>
            <MDBCard className="shadow-0 border-0">
                <MDBCardBody style={{ padding: '2rem' }}>

                    <div className="d-flex align-items-center mb-4">
                        <div className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{ width: '60px', height: '60px' }}>
                            <MDBIcon fab icon="whatsapp" size="2x" className="text-success" />
                        </div>
                        <div>
                            <MDBTypography tag="h4" className="mb-1 fw-bold">
                                WhatsApp Business
                            </MDBTypography>
                            <span className="text-muted">
                                {isConnected ? 'Connected' : 'Connect your account'}
                            </span>
                        </div>
                    </div>

                    {isLoading && (
                        <div className="alert alert-info">
                            <MDBSpinner size="sm" className="me-2" />
                            Connecting to WhatsApp...
                        </div>
                    )}

                    {error && (
                        <div className="alert alert-danger">
                            {error}
                        </div>
                    )}

                    {isConnected && accountInfo && (
                        <div className="alert alert-success">
                            <strong>Connected Successfully!</strong>
                            <div>Phone: {accountInfo.displayphonenumber}</div>
                            <div>Name: {accountInfo.verifiedname}</div>
                        </div>
                    )}

                    {!isConnected ? (
                        <MDBBtn
                            color="success"
                            className="w-100"
                            onClick={launchWhatsAppSignup}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Connecting...' : 'Connect WhatsApp Business'}
                        </MDBBtn>
                    ) : (
                        <MDBBtn
                            color="danger"
                            outline
                            className="w-100"
                            onClick={disconnectWhatsApp}
                        >
                            Disconnect Account
                        </MDBBtn>
                    )}

                </MDBCardBody>
            </MDBCard>
        </div>
    </div>
      
    );
}